import React from "react";
import { Navigate } from "react-router-dom";
import { TokenManager } from "../helpers/api_helper";

const getAuthenticatedHomePath = () =>
  TokenManager.getUserType() === "affiliate" ? "/affiliate/dashboard" : "/dashboard";

const hasActiveSession = () => {
  const accessToken = TokenManager.getAccessToken();
  if (!accessToken) return false;

  const refreshToken = TokenManager.getRefreshToken();
  const refreshExpired = refreshToken ? TokenManager.isRefreshTokenExpired() : false;

  if (refreshExpired) return false;
  if (TokenManager.isTokenExpired() && !refreshToken) return false;

  return true;
};

const AuthenticatedRedirect = ({ children }: { children: React.ReactElement }) => {
  if (hasActiveSession()) {
    return <Navigate to={getAuthenticatedHomePath()} replace />;
  }

  return children;
};

const AuthenticatedHomeRedirect = () => (
  <Navigate to={getAuthenticatedHomePath()} replace />
);

export { AuthenticatedHomeRedirect, AuthenticatedRedirect, getAuthenticatedHomePath, hasActiveSession };
